/**
 * Contrat métier : une mise à jour Nexxus remplace uniquement le programme.
 * Les données (SQLite, secure-store, coffre-fort) restent dans le dossier utilisateur OS.
 */

export const USER_DATA_DIR_HINT_MAC =
  '~/Library/Application Support/nexxus-erp/';
export const USER_DATA_DIR_HINT_WIN = '%APPDATA%\\nexxus-erp\\';
export const USER_DATA_DIR_HINT_LINUX = '~/.config/nexxus-erp/';

export function userDataDirHint(platform: 'mac' | 'win' | 'linux' | string): string {
  if (platform === 'mac' || platform === 'darwin') return USER_DATA_DIR_HINT_MAC;
  if (platform === 'win' || platform === 'win32') return USER_DATA_DIR_HINT_WIN;
  return USER_DATA_DIR_HINT_LINUX;
}

/** Texte de confirmation avant téléchargement / installation. */
export function updatePreserveConfirmMessage(
  fromVersion: string,
  toVersion: string,
  platform: string,
): string {
  const dataDir = userDataDirHint(platform);
  return [
    `Passer de v${fromVersion} à v${toVersion}.`,
    '',
    'Vos données métier (salariés, paie, compta, licences) ne seront PAS effacées.',
    `Elles restent dans : ${dataDir}`,
    '',
    platform === 'mac' || platform === 'darwin'
      ? 'Sur macOS, ouvrez le .dmg, glissez Nexxus dans Applications, puis relancez — l’installateur ne remplace pas le programme tout seul.'
      : 'Seule l’application (programme) est remplacée. Une sauvegarde chiffrée sera exigée juste avant.',
    '',
    'Ne désinstallez pas Nexxus et n’effacez pas ce dossier.',
  ].join('\n');
}

/** Message dialogue sauvegarde obligatoire. */
export function updateMandatoryBackupMessage(targetVersion: string): string {
  return [
    `Sauvegarde chiffrée obligatoire avant la version ${targetVersion}.`,
    'Choisissez un mot de passe (8 caractères minimum) et conservez le fichier .nexxus-backup.',
    'Ensuite l’installateur remplacera uniquement le programme — pas vos données.',
  ].join(' ');
}
